
<template>
    <v-select
    :items="filteredSellers" 
    label="Bayi"
    item-text="title"
    item-value="id"
    required
  ></v-select>
</template>


<script>

import { useStore } from 'vuex';
import { computed } from 'vue';

export default {
    name: "SellerSelect",
    setup() {
    const store = useStore();

    // sellerList'i store'dan al
    const sellerList = computed(() => store.state.sellerList);

    // status'u true olanları filtrele
    const filteredSellers = computed(() => {
        console.log(sellerList.value);
      return sellerList.value.filter(seller => seller.status === true);
    });

    return {
      filteredSellers, // Filtrelenmiş satıcıları döndür
    };
  },
}
</script>